import apiClient from './api-client';
import logger from '../shared/utils/logger';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface  LoginResponse {
  data: string;
}

export interface UserProfile {
  id: number;
  username: string;
  name: string;
  email: string;
  role: string;
  isAdmin: boolean;
}

/**
 * Authentication service
 */
class AuthService {
  /**
   * Login with username and password
   * @param credentials The login credentials
   * @returns Promise with the login response
   */
  public async login(credentials: LoginCredentials): Promise<LoginResponse> {
    return apiClient.post<LoginResponse>('/auth/login', credentials, { skipErrorToast: true });
  }

  /**
   * Logout the current user
   * @returns Promise with the logout response
   */
  public async logout(): Promise<void> {
    return apiClient.post<void>('/auth/logout');
  }

  /**
   * Get the current authenticated user
   * @returns Promise with the user profile
   */
  public async getCurrentUser(): Promise<UserProfile | null> {
    try {
      return await apiClient.get<UserProfile>('/auth/me');
    } catch (error: unknown) {
      logger.error('Error fetching current user:', error);
      return null;
    }
  }

  /**
   * Check if the current token is valid
   * @returns Promise with the validation result
   */
  public async validateToken(): Promise<boolean> {
    try {
      await apiClient.get('/auth/me');
      return true;
    } catch (error: unknown) {
      return false;
    }
  }
}

// Create and export a singleton instance
const authService = new AuthService();
export default authService; 